    <!-- eslint-disable vue/no-v-html -->
<template>
  <div>
    <template v-if="regType === 'iStock'">
      <ProgressBar />
      <PageHeading :default-heading="pageHeader" />
      <div class="pvd-container container-divider">
        <p>{{ pageText }}</p>
        <p v-html="pageLink" />
      </div>
    </template>
    <template v-else>
      <ProgressBar />
      <PageHeading :default-heading="pageHeader" />
      <div class="pvd-container container-divider">
        <p>{{ pageText }}</p>
      </div>
      <div
        class="pvd-container pvd-btn-row"
      >
        <div
          v-if="!isMaestro() && !isLiteView()"
          class="button-group"
        >
          <button
            class="pvd-btn btn-action"
            @click.prevent="exitLink()"
          >
            {{ startApplication }}
          </button>
        </div>
        <div
          v-if="!isMaestro() && !isLiteView()"
          class="tertiary-link xsmall"
        >
          <a
            id="exit-overlay-modal-trigger"
            href="javascript:void(0)"
            @click.prevent="exitLink()"
          >
            {{ modalExitVal }}
          </a>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import PageHeading from '../components/PageHeading.vue';
import dataHelper from '../mixins/dataHelper';
import ProgressBar from '../components/ProgressBar.vue';
import measurement from '../mixins/measurement';
import utility from '../mixins/utility';
import constants from '../mixins/constants';

export default {
  name: 'SessionTimeout',
  components: {
    PageHeading,
    ProgressBar,
  },
  mixins: [dataHelper, measurement, utility],
  data() {
    return {
      backButtonAttempt: false,
      regType: '',
    };
  },
  computed: {
    pageHeader() {
      return this.pd_content.session_timeout_page_header || constants.SESSION_TIMEOUT_PAGE_HEADER;
    },
    pageText() {
      return this.pd_content.session_timeout_text || constants.SESSION_TIMEOUT_TEXT;
    },
    pageLink() {
      return this.pd_content.session_timeout_link
        ? `<a href="${this.pd_content.session_timeout_link.url}">${this.pd_content.session_timeout_link.link_text}</a> ${this.pd_content.session_timeout_link.post_text}`
        : '<a href="https://nb.fidelity.com/public/nb/default/home">Return to NetBenefits<sup>®</sup></a> to continue your application.';
    },
    modalExitVal() {
      return this.pd_content.exit_link ? this.pd_content.exit_link.value : constants.EXIT;
    },
    startApplication() {
      return this.pd_content.start_application_text || constants.START_NEW_APPLICATION;
    },
  },
  beforeMount() {
    this.regType = this.getRegType(document.location.pathname);
  },
  mounted() {
    this.track('session-timeout', 'pageview');
    document.title = this.setTitle(this.pageHeader);
    this.resetFormData();
    this.configureBackButtonFunctionality(() => this.showBackWarning(
      this.pd_content.back_button_disabled_warning,
    ));
  },
  methods: {
    exitLink() {
      window.location = this.pd_content.overlay_exit_link ? this.pd_content.overlay_exit_link.overview_url : constants.OVERVIEW_URL;
    },
  },
};
</script>

<style scoped>
    body {
        padding: 0 !important;
    }
</style>
